import { all } from "redux-saga/effects";
import notesSagas from "./Notes";
import baseConfigSagas from "./BaseConfig";
import dashboardSagas from "./Dashboard";
import newsSagas from "./News";
import downloadSagas from "./Download";
import instance from "./Instance";
import reminder from "./Reminder";
import letter from "./Letter";
import attachment from "./Attachment";
import letterBody from "./LetterBody";
import convertStatus from "./ConvertStatus";
import secretariatList from "./Secratariat";
import letterReferTypesStatics from "./LetterReferTypesStatics";
import employeePositionFolders from "./EmployeePositionFolders";
import assign from "./Assign";
import archive from "./Archive";
import newLetter from "./NewLetter";
import contact from "./Contact";
import employeePosition from "./EmployeePosition";
import getGuid from "./GetGuid";
import uploadFile from "./UploadFile";
import deleteDraft from "./DeleteDraft";
import signature from "./Signature";
import sendLetter from "./SendLetter";
import fastSign from "./FastSign";
import memo from "./Memo";
import folder from "./Folder";
import letterRelation from "./LetterRelation";
import fgChat from "./ChatV2";
import appointment from "./Appointment";
import bpm from "./Bpm";
import userConfig from "./UserConfig";

export default function* rootSaga(getState: any) {
  yield all([
    notesSagas(),
    baseConfigSagas(),
    dashboardSagas(),
    newsSagas(),
    downloadSagas(),
    instance(),
    reminder(),
    letter(),
    attachment(),
    letterBody(),
    convertStatus(),
    secretariatList(),
    letterReferTypesStatics(),
    employeePositionFolders(),
    contact(),
    employeePosition(),
    assign(),
    newLetter(),
    getGuid(),
    uploadFile(),
    deleteDraft(),
    signature(),
    sendLetter(),
    archive(),
    fastSign(),
    memo(),
    folder(),
    letterRelation(),
    fgChat(),
    appointment(),
    bpm(),
    userConfig()
  ]);
}
